(() => {
  const selector = '.umi-participant-note__field';
  let currentNote = '';
  let saveTimer;

  const rootPath = window.Shopify?.routes?.root || '/';

  async function loadCartNote() {
    try {
      const response = await fetch(`${rootPath}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      currentNote = cart.note || '';
      syncFields();
    } catch (_) {}
  }

  function syncFields(source) {
    document.querySelectorAll(selector).forEach((field) => {
      if (field !== source && document.activeElement !== field) field.value = currentNote;
    });
  }

  function saveNote(note, source) {
    currentNote = note;
    syncFields(source);
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(async () => {
      try {
        await fetch(`${rootPath}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: currentNote })
        });
      } catch (_) {}
    }, 450);
  }

  function createParticipantNote() {
    const wrapper = document.createElement('div');
    wrapper.className = 'umi-participant-note';
    wrapper.innerHTML = `
      <label class="umi-participant-note__label">Upplýsingar um þátttakanda</label>
      <p class="umi-participant-note__help">Ef þátttakandi er annar en greiðandi, vinsamlegast skráðu nafn og aldur þátttakanda hér. Ef keypt eru fleiri en eitt pláss, skráðu nafn og aldur allra þátttakenda.</p>
      <textarea class="umi-participant-note__field" aria-label="Nafn og aldur þátttakanda" placeholder="Nafn og aldur þátttakanda / þátttakenda"></textarea>
    `;

    const field = wrapper.querySelector(selector);
    field.value = currentNote;
    field.addEventListener('input', () => saveNote(field.value, field));
    field.addEventListener('blur', () => saveNote(field.value, field));
    return wrapper;
  }

  function mountNotes() {
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const parent = ctas.parentElement;
      if (!parent || parent.querySelector('.umi-participant-note')) return;
      ctas.before(createParticipantNote());
    });
  }

  function normalizePurchaseActions() {
    document.querySelectorAll('.product-form-buttons--umi').forEach((formButtons) => {
      if (formButtons.querySelector(':scope > .umi-purchase-actions')) return;

      const directChildren = Array.from(formButtons.children);
      const addWrapper = directChildren.find((child) => child.querySelector?.('.add-to-cart-button'));
      const acceleratedWrapper = directChildren.find(
        (child) => child.classList?.contains('accelerated-checkout-block') || child.querySelector?.('.accelerated-checkout-block')
      );

      if (!addWrapper || !acceleratedWrapper || addWrapper === acceleratedWrapper) return;

      const actions = document.createElement('div');
      actions.className = 'umi-purchase-actions';
      formButtons.insertBefore(actions, addWrapper);
      actions.appendChild(addWrapper);
      actions.appendChild(acceleratedWrapper);
    });
  }

  function init() {
    mountNotes();
    normalizePurchaseActions();
    loadCartNote();

    const observer = new MutationObserver(() => {
      mountNotes();
      normalizePurchaseActions();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
